module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-723-min.ff77f438.jpg";